import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import CoulureConceptHero from "@/components/Svgs/coulure-concept-hero";
import { PrismicImage, PrismicRichText } from "@prismicio/react";
import Link from "next/link";

/**
 * @typedef {import("@prismicio/client").Content.HeroConceptSlice} HeroConceptSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<HeroConceptSlice>} HeroConceptProps
 * @param {HeroConceptProps}
 */

const Default = ({ slice, context, index }) => {
  return <section
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
    className={`relative overflow-hidden border-solid relative ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}
    style={{ backgroundImage: `url(${slice.primary.bg_picture.url}); background-size: cover` }}
    aria-label={slice.primary.bg_picture.alt}>
    <div className="absolute w-full h-full">
      <img srcSet="images/coulure-concept-hero-mobile.svg 640w, images/coulure-concept-hero.svg"  loading={index === 0 ? '' : 'lazy'}
        className="w-full h-full object-cover object-left-top" alt="Coulure" />
    </div>
    <div className="pb-[54px] pt-[87px] md:pb-10 md:pt-[100px] px-4 md:px-7 lg:px-10 relative z-[10] max-w-[1400px] m-auto">
      <Breadcrumbs context={context} index={index} />
      <div className="flex">
        <div className="flex md:basis-[600px]">
          <div className=" flex flex-col">
            <div className="h1-like mb-7 md:mb-0 md:w-[450px]">
              <PrismicRichText field={slice.primary.title} />
            </div>
            <div className="w-[300px] md:w-[350px]">
              <PrismicRichText field={slice.primary.text} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}

const PictureOnTheSide = ({ slice, context, index }) => {
  return <section
    data-slice-type={slice.slice_type}
    data-slice-variation={slice.variation}
    className={`relative overflow-hidden relative bg-${slice.primary.bg_color} ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}>
    <div className="pt-[87px] pb-10 md:pt-[100px] px-4 md:px-7 lg:px-10 relative z-[10] max-w-[1400px] m-auto">
      <div className="flex flex-col md:flex-row gap-5 md:gap-20">
        <div className="flex md:basis-2/3">
          <div className="flex flex-col">
          <Breadcrumbs context={context} index={index} />
            <div className="h1-like mb-5">
              <PrismicRichText field={slice.primary.title} />
            </div>
            <PrismicRichText field={slice.primary.text} />
          </div>
        </div>
        <div className="w-full h-[220px] md:max-h-[350px] md:w-full md:h-full md:max-w-[350px] md:aspect-square rounded-3xl md:rounded-full overflow-hidden border-2 border-dark-grey">
          <PrismicImage className="w-full h-full object-cover object-center" field={slice.primary.picture}   loading={index === 0 ? '' : 'lazy'}/>
        </div>
      </div>
    </div>
  </section>
}

const HeroConcept = ({ slice, index, context }) => {

  return slice.variation === "default" ?
    <Default slice={slice} index={index} context={context} /> :
    <PictureOnTheSide slice={slice} index={index} context={context} />;
};

export default HeroConcept;
